import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ApplicationService } from '@app/core/services/application/application.service';
import { SubjectService } from '@app/core/services/subject/subject.service';
import { ToastService } from '@app/core/services/toast/toast.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { UserService } from '@app/core/services/user/user.service';
import { ModalService } from '@core/services/modal/modal.service';
import { faFile, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { faExclamationCircle, faFileEdit, faCheckCircle, faUpload } from '@fortawesome/pro-solid-svg-icons';
import { faFileCheck, faFileDownload, faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { ModalController, PopoverController } from '@ionic/angular';
import { UploadComponent } from '../document-upload/document-upload.component';
import { RequirementItems } from '@app/core/interfaces/RequirementChecklist';
import { MutationService } from '@app/core/graphql/mutation/mutation.service';
import moment from 'moment';
import { Observable, Subscription, flatMap, of } from 'rxjs';
import { ApplicationInformationTooltipComponent } from '../application-information-tooltip/application-information-tooltip.component';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { WarningService } from '@app/core/services/warning/warning.service';
import { DocumentService } from '@app/core/services/document/document.service';
import { format, isAfter, toDate } from 'date-fns';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DocumentStatusChipComponent } from '../document-status-chip/document-status-chip.component';
import { ChecklistPipe } from '@app/shared/pipes/checklist/checklist.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterModule } from '@angular/router';
import { SafePipe } from '@shared/pipes/safe/safe.pipe';
import { NbspToSpacePipe } from '@shared/pipes/nbsp-to-space/nbsp-to-space.pipe';

@Component({
    selector: 'app-eligibility-documents',
    templateUrl: './eligibility-documents.component.html',
    styleUrls: ['./eligibility-documents.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        DocumentStatusChipComponent,
        ChecklistPipe,
        FontAwesomeModule,
        RouterModule,
        SafePipe,
        NbspToSpacePipe,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class EligibilityDocumentsComponent implements OnChanges {
    // main user document list
    userDocuments: any = {};
    uploadedCV = false;
    uploadedLOR = false;
    filteredKeys: any = [];

    hasUsCanPassport: boolean = false;
    isOnlineTelehealth: boolean = false;

    customDocumentList: any[];
    requiredDocumentList: any = {};

    newRequirementDocumentList: any[] = [];

    customResume = false;
    customEducation = false;

    textcontent: any;

    @Input() status: any; // main application object

    // Icons
    faQuestionCircle = faQuestionCircle;

    icons: any = {
        rejectedOrAccepted: faExclamationCircle,
        blocked: faFileEdit,
        completed: faCheckCircle,
        incompleted: faUpload,
        faInfoCircle: faInfoCircle,
        faFile: faFile,
        question: faQuestionCircle,
        acknowledged: faFileCheck,
        download: faFileDownload,
    };

    showDynamicCopy = this.toolService.getDynamicEligibility();

    userSubmission: boolean; // checks if user needs to submit a document a document from pre acceptance requirements
    checklistStatus: any = null;

    submissionString: string;
    submittedString: string;
    //
    //
    @ViewChild('downloadZipLink', { static: false })
    private downloadZipLink: ElementRef;

    constructor(
        private modalCtrl: ModalController,
        private toastService: ToastService,
        public toolService: ToolService,
        private modalService: ModalService,
        private userService: UserService,
        private applicationService: ApplicationService,
        private mutationService: MutationService,
        private popoverCtrl: PopoverController,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
        private warning: WarningService,
        private documentService: DocumentService
    ) {}

    ngOnChanges() {
        this.hasUsCanPassport = ['United States', 'Canada'].includes(this.status.user.passportissuecountry);

        this.isOnlineTelehealth = this.status.application.type.includes('Virtual') ? true : false;

        this.requiredDocumentList = { ...this.status.application.program.requiredpredocumentlist }; // raw document requirements

        this.customDocumentList = [...this.status.singleApplicationRequirementList]
            .map((m) => {
                this.userDocuments[m['ApplicationRequirements.jsondata'].name];
                return {
                    applicationRequirementId: m['ApplicationRequirements.applicationRequirementId'],
                    documentId: m['ApplicationRequirements.Documents.id'],
                    Document: {
                        key: m['ApplicationRequirements.Documents.uri'],
                        filename: m['ApplicationRequirements.Documents.filename'],
                    },
                    level: m.level,
                    levelid: m.programid !== null ? m.programid : m.departmentid !== null ? m.departmentid : m.hostid !== null ? m.hostid : null,
                    jsondata: m['ApplicationRequirements.jsondata'],
                };
            })
            .filter((b) => {
                return b.jsondata.preapproval;
            });

        // file upload document name custom
        this.newRequirementDocumentList = this.status.singleApplicationRequirementList.documents;
        this.userDocuments.cv = this.status.user.item1name === null ? false : this.status.user.item1name.indexOf('Temporary') !== -1 ? false : true;
        // this.userDocuments.schoolrecords = this.status.user.item4name === null ? false : true;
        this.userDocuments.passport = this.status.user.item2name === null ? false : true;
        this.userDocuments.schoolrecords = this.status.user.item4name === null ? false : true;
        // if documents list is empty user has no submitted immunizations
        this.userDocuments.immune =
            !this.isOnlineTelehealth && !this.status.immunizations.documents ? false : this.status.immunizations.documents.length === 0 ? false : true;
        this.userDocuments.letterofrecc = this.status.user.item6name === null ? false : true;
        this.userDocuments.visaproof = !this.hasUsCanPassport && this.status.user.item7name === null ? false : true;
        //this.userDocuments.healthinsurance = !this.isOnlineTelehealth && this.status.user.item8name === null ? false : true;
        this.userDocuments.healthinsurance =
            this.status.applicationHealthinsuranceDocument && this.status.applicationHealthinsuranceDocument.documents.length > 0 ? true : false;

        this.userDocuments.toefl = !this.hasUsCanPassport && this.status.user.item10name === null ? false : true;

        this.userDocuments.passportform = this.hasUsCanPassport
            ? true
            : ((this.status.user.passportexpiredate && this.status.user.passportissuedate) || this.status.user.visameetingdate) &&
              this.status.user.passportnumber
            ? true
            : false;

        this.userDocuments.purchasedMalpractice = this.status.applicationDocuments.documents.some((document: any) => {
            if (document.filename.indexOf('Malpractice') !== -1) {
                this.userDocuments.malpracticeLink = document.url;
                return true;
            } else {
                return false;
            }
        });

        // check pre approval docs are present and set file names to this.userDocuments
        // then check if the file names match user submittedProgramDocuments and uploaded
        // this only checks in submitted documents, not immune or general user docs

        if (this.customDocumentList && this.customDocumentList.length > 0) {
            this.customDocumentList.forEach((req: any) => {
                if (req.jsondata.type === 'resume') {
                    this.customResume = true;
                }
                if (req.jsondata.type === 'education') {
                    this.customEducation = true;
                }
                //console.log(req,this.status.submittedDocumentsRequirements);
                //requirements/32f92c02-b968-4431-a291-4698c9170229/program/100000075
                if (this.status.submittedDocumentsRequirements && Array.isArray(this.status.submittedDocumentsRequirements)) {
                    this.status.submittedDocumentsRequirements.forEach((a) => {
                        //if (req.applicationRequirementId === a) {
                        if (a.url.indexOf(`requirements/${req.applicationRequirementId}`) > 0) {
                            req.submitted = true;
                            // add url here
                            req.urlSubmitted = a.url;
                            this.filteredKeys.push(req.jsondata.name);
                            this.userDocuments[req.jsondata.name] = req.jsondata.name;
                        }
                    });
                }

                // if pre approval has a file type of immunization and status immune has any length
                if (req.type === 'immunization') {
                    if (this.status.immunizations && this.status.immunizations.documents && this.status.immunizations.documents.length > 0) {
                        this.userDocuments[req.jsondata.name] = true;
                    }
                }
                if (req.type === 'education') {
                    this.userDocuments[req.jsondata.name] = this.userDocuments.schoolrecords;
                }
                if (req.type === 'resume') {
                    this.userDocuments[req.jsondata.name] =
                        this.status.user.item1name === null ? false : this.status.user.item1name.indexOf('Temporary') !== -1 ? false : true;
                }

                // check for downloaded/acknowledged
                if (this.status.user.application.submittedrequirements && this.status.user.application.submittedrequirements.length > 0) {
                    if (!req.jsondata.usersubmission) {
                        if (this.status.user.application.submittedrequirements.some((doc) => doc.applicationrequirementid === req.applicationRequirementId)) {
                            const submittedRequirement = this.status.user.application.submittedrequirements.find(
                                (doc) => doc.applicationrequirementid === req.applicationRequirementId
                            );

                            if (submittedRequirement.submittedValues && submittedRequirement.submittedValues.acknowledged) {
                                req.submitted = true;
                                this.userDocuments[req.jsondata.name] = req.jsondata.name;
                            }
                        }
                    }
                }
            });
        }
        // check if user has already completed some requirements for pre acceptance
        setTimeout(() => {
            if (!this.status.application.preacceptancereviewable && this.userDocuments.cv) {
                this.triggerPreApprovedNotification();
            }
        }, 100);
        //console.log("this.userDocuments", this.userDocuments);
        //console.log("this.status", this.status);
        //console.log("this.status.user new",this.status.user);
        //console.log("this.status.user.application.checklist new",this.status.user.application.checklist);
        if (this.status.user.application) {
            if (this.status.user.application.checklist) {
                this.checklistStatus = this.status.user.application.checklist;
            }
        }

        this.toolService.content.subscribe((textcontent: any) => (this.textcontent = textcontent));
    }

    downloadThenUploadModal(
        item?: string,
        key?: string,
        filename?: string,
        index?: number,
        requirementName?: string,
        usersubmission?: boolean,
        applicationRequirement_Id?: string,
        leveltype?: string,
        levelid?: string
    ) {
        const completeUserProfile = {
            ...this.status.user,
            programid: this.status.application.programid,
            applicationid: this.status.application.id,
        };

        let applicationidList = [];
        applicationidList.push(this.status.application.id);

        const type =
            item === 'education'
                ? 'schoolrecords'
                : item === 'resume'
                ? 'cv'
                : item === 'visa'
                ? 'visaproof'
                : item === 'passport'
                ? 'passport'
                : item === 'english'
                ? 'toefl'
                : item === 'immunization'
                ? 'immune'
                : item === 'immune'
                ? 'immune'
                : item === 'healthInsurance'
                ? 'healthinsurance'
                : item === 'malpractice'
                ? 'malpractice'
                : 'application';

        this.modalService
            .upload(type, completeUserProfile, null, key, requirementName, usersubmission, applicationRequirement_Id, applicationidList, {
                levelType: leveltype,
                levelId: levelid,
            })
            .then((response: any) => {
                if (response.data.result) {
                    if (index !== null && index !== undefined) {
                        this.userDocuments[requirementName] = true;
                        this.customDocumentList[index].urlSubmitted = true;
                        this.applicationService.enrollmentSubject.next(true);
                        this.successUpload();
                    } else if (item === 'immune' || item === 'malpractice') {
                        //everything handled at document-upload component
                        //this.status.immunizations.documents.push('immunization');
                        this.applicationService.enrollmentSubject.next(true);
                        //this.successUpload();
                    } else {
                        this.userDocuments[requirementName] = true;
                        this.applicationService.enrollmentSubject.next(true);
                        this.successUpload();
                    }

                    const targetedRequirement = this.customDocumentList.find(
                        (requirement) => requirement.applicationRequirementId == applicationRequirement_Id
                    );

                    const checklistItem = this.status.user.application.checklist.find(
                        (item) => item.requirementid === targetedRequirement.applicationRequirementId
                    );

                    if (checklistItem) {
                        this.updateRequirementStatus({
                            ...checklistItem,
                            ischecked: false,
                            status: 'Pending',
                            type:
                                type === 'application' && targetedRequirement.jsondata.preapproval
                                    ? 'preapproval'
                                    : type === 'application' && targetedRequirement.jsondata.postreservation
                                    ? 'postreservation'
                                    : type,
                            uploadedAt: moment(new Date()).utc().format(),
                        });
                    }
                }
            });
    }

    async upload(item: string, docName: string, urlfragment?: string) {
        const data = {
            id: this.status.user.id,
            name: this.status.user.name,
            programid: this.status.application.programid,
            applicationid: this.status.application.id,
        };

        const modal = await this.modalCtrl.create({
            component: UploadComponent,
            componentProps: {
                uploadItem: item,
                profile: data,
                url: urlfragment,
                uploadIdentity: item,
                usersubmission: this.userSubmission,
                applicationid: this.status.application.id,
            },
            backdropDismiss: false,
        });

        await modal.present();

        modal
            .onDidDismiss()
            .then((response: any) => {
                if (response && response.data && response.data.result && response.data.result == 'error') {
                    //*
                } else if (response && response.data && response.data.result && item != 'immune') {
                    //*
                    if (this.userDocuments.hasOwnProperty(docName)) {
                        this.userDocuments[docName] = true;
                    }
                    this.userDocuments[response.data.key] = true;
                    this.successUpload();

                    const checklistItem = this.status.user.application.checklist.find((checklistItem) => checklistItem.type === item);

                    if (checklistItem) {
                        this.updateRequirementStatus({
                            ...checklistItem,
                            status: 'Pending',
                            uploadedAt: moment(new Date()).utc().format(),
                        });
                    }
                    // else {
                    //     const newChecklistRequirementItem: RequirementItems = {
                    //         requirementid: uuid.v4(),
                    //         ischecked: false,
                    //         iscustom: false,
                    //         label: 'test',
                    //         status: 'Pending',
                    //         type: item,
                    //         uploadedAt: moment(new Date()).utc().format(),
                    //     };
                    // }
                    //else - handled at document-upload component for immune
                }
            })
            .catch((err: Error) => {
                console.log('upload modal error: ', err);
            });
    }

    uploadPreAcceptanceDoc = (
        item: string,
        applicationRequirementId?: string,
        requirementName?: string,
        index?: number,
        levelType?: string,
        levelId?: string
    ) => {
        const completeUserProfile = {
            ...this.status.user,
            programid: this.status.application.programid,
            applicationid: this.status.application.id,
        };

        let applicationidList = [];
        applicationidList.push(this.status.application.id);

        const type =
            item === 'education'
                ? 'schoolrecords'
                : item === 'cv'
                ? 'cv'
                : item === 'visa'
                ? 'visaproof'
                : item === 'passport'
                ? 'passport'
                : item === 'english'
                ? 'toefl'
                : item === 'immunization'
                ? 'immune'
                : item === 'immune'
                ? 'immune'
                : item === 'healthInsurance'
                ? 'healthinsurance'
                : item === 'malpractice'
                ? 'malpractice'
                : 'application';

        this.modalService
            .upload(type, completeUserProfile, null, null, requirementName, null, applicationRequirementId, applicationidList, {
                levelType: levelType,
                levelId: levelId,
            })
            .then((response: any) => {
                if (response && response.data && response.data.result && response.data.result == 'error') {
                    /* empty */
                } else if (response.data.result && response.data.result != '') {
                    if (index !== null && index !== undefined) {
                        //*
                        //console.log("indexed..", index);
                        this.userDocuments[requirementName] = true;
                        this.applicationService.enrollmentSubject.next(true);
                        this.successUpload();
                    } else if (item === 'immune' || item === 'malpractice') {
                        //this.status.immunizations.documents.push('immunization');
                        this.applicationService.enrollmentSubject.next(true);
                        //this.successUpload();
                    } else {
                        this.userDocuments[response.data.key] = true;
                        this.applicationService.enrollmentSubject.next(true);
                        this.successUpload();
                    }

                    const targetedRequirement = this.customDocumentList.find((requirement) => requirement.applicationRequirementId == applicationRequirementId);

                    const checklistItem = this.status.user.application.checklist.find(
                        (item) => item.requirementid === targetedRequirement.applicationRequirementId
                    );

                    if (checklistItem) {
                        this.updateRequirementStatus({
                            ...checklistItem,
                            ischecked: false,
                            status: 'Pending',
                            type:
                                type === 'application' && targetedRequirement.jsondata.preapproval
                                    ? 'preapproval'
                                    : type === 'application' && targetedRequirement.jsondata.postreservation
                                    ? 'postreservation'
                                    : type,
                            uploadedAt: moment(new Date()).utc().format(),
                        });
                    }
                }
            });
    };

    uploadAdditionalDocs = (item: string, url?: string, filename?: string, usersubmission?: boolean, index?: any) => {
        const userpacket = {
            id: this.status.user.id,
            name: this.status.user.name,
            programid: this.status.application.programid,
            applicationid: this.status.application.id,
        };

        this.modalService.upload(item, userpacket, this.status.application.id, url, filename, usersubmission).then((response: any) => {
            if (response.data.result) {
                if (index !== null && index !== undefined) {
                    this.userDocuments[filename] = true;
                    this.applicationService.enrollmentSubject.next(true);
                    this.successUpload();
                } else if (item === 'immune' || item === 'malpractice') {
                    //this.status.immunizations.documents.push('immunization');
                    //this.userDocuments[filename] = true;
                    this.applicationService.enrollmentSubject.next(true);
                    //this.successUpload();
                } else {
                    this.userDocuments[response.data.key] = filename;
                    this.applicationService.enrollmentSubject.next(true);
                    this.successUpload();
                }
            }
        });
    };

    successUpload() {
        this.toastService.create({
            message: 'Document uploaded.',
            duration: 3000,
            position: 'center',
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    },
                },
            ],
            closeButtonText: 'Done',
            color: 'primary',
        });

        setTimeout(() => {
            this.triggerPreApprovedNotification();
        }, 2000);
    }

    triggerPreApprovedNotification() {
        const filteredRequirements = this.filteredKeys.reduce((obj, key) => ({ ...obj, [key]: this.userDocuments[key] }), {});
        // const completedBasicRequirements = Object.values(this.userDocuments).reduce(
        //   (a: string, item: boolean) => a + (item === true ? 1 : 0), 0);

        // const requiredDocumentListCount = Object.values(this.requiredDocumentList).reduce((a: number, item: boolean) => a + (item === true ? 1 : 0), 0);

        const completedAdditionalRequirements = Object.values(filteredRequirements).reduce((a: string, item: boolean) => a + (item === true ? 1 : 0), 0);

        const completedUploads = document.querySelectorAll('.custom-document-button-complete').length;

        const numberOfUploadButtons = document.querySelectorAll('.ion-button-document').length;
        //
        // Check if custom requirements are available and submitted
        const checkForCustomRequirements =
            this.customDocumentList.length === 0 ? false : completedAdditionalRequirements === this.customDocumentList.length ? true : false;

        if (checkForCustomRequirements || (filteredRequirements !== undefined && completedUploads === numberOfUploadButtons)) {
            this.applicationService.requestPreAcceptanceReview(this.status.application.id).subscribe((response: any) => {
                /* empty */
            });
        }
    }

    openPassportModal() {
        this.modalService
            .passport(this.status.application.id)
            .then((response: any) => {
                // console.log(response);
                if (response.data.update) {
                    this.toastService.create({
                        message: 'Passport information submitted.',
                        duration: 3000,
                        position: 'top',
                        buttons: [
                            {
                                text: 'Close',
                                role: 'cancel',
                                handler: () => {
                                    console.log('Cancel clicked');
                                },
                            },
                        ],
                        closeButtonText: 'Done',
                        color: 'primary',
                    });
                    this.status.passportform = true;
                    this.applicationService.enrollmentSubject.next(true);
                }
            })
            .catch((err: Error) => {
                // console.log(err);
            });
    }

    clearDocument(docname: any) {
        const docname_map = {
            cv: 1,
            passport: 2,
            schoolrecords: 4,
            visaproof: 7,
            healthinsurance: 8,
            toefl: 10,
        };
        const request = {
            userid: this.status.user.id,
            itemno: docname_map[docname], // < 0 means that its an app doc and not a regular user doc
            originalfilename: '',
        };

        this.modalService
            .confirmation({
                title: 'Cancel Document',
                message: `
            You are about to clear the "${docname}" document: \n\n`,
                buttonText: `Yes, clear this document.`,
                buttonColor: 'danger',
            })
            .then((result) => {
                if (result.data.confirmed) {
                    this.clearDocumentFromUser(request, docname);
                }
            });
    }

    clearDocumentFromUser(request, type: string) {
        this.userService
            .archiveUploadedDocument(request)
            .pipe(
                flatMap((response) => {
                    return of(response.success);
                }),
                flatMap((clear) => {
                    if (clear) {
                        const checklistItem: RequirementItems =
                            this.status.user.application.checklist &&
                            this.status.user.application.checklist.find((checklistItem: RequirementItems) => checklistItem.type === type);

                        if (checklistItem) {
                            return of(
                                this.updateRequirementStatus({
                                    ...checklistItem,
                                    status: 'Missing',
                                    uploadedAt: null,
                                })
                            );
                        } else {
                            return of({ success: true });
                        }
                    } else {
                        return of({ success: false });
                    }
                })
            )
            .subscribe((response) => {
                setTimeout(() => {
                    location.reload();
                }, 1000);
            });
    }

    clearAdditionalReqDocument(data: any) {
        if (this.status.user && this.status.user.id) {
            let filename = `userdocuments/${this.status.user.id}/requirements/${data.applicationRequirementId}/${data.level}/${data.levelid}/${data.jsondata.name}`;
            const request = {
                userid: this.status.user.id,
                itemno: -1, // < 0 means that its an app doc and not a regular user doc
                originalfilename: filename,
            };

            let usrService = this.userService.archiveUploadedDocument;

            this.modalService
                .confirmation({
                    title: 'Cancel Document',
                    message: `
                You are about to clear the "${data.jsondata.name}" document: \n\n`,
                    buttonText: `Yes, clear this document.`,
                    buttonColor: 'danger',
                })
                .then(function (result) {
                    if (result.data.confirmed) {
                        usrService(request).subscribe((res) => {
                            if (res.success) {
                                location.reload();
                            }
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }

    updateClearAdditionalRquirementStatus(data) {
        const targetedRequirement = this.customDocumentList.find((requirement) => requirement.applicationRequirementId == data.applicationRequirementId);

        const checklistItem = this.status.user.application.checklist.find((item) => item.requirementid === targetedRequirement.applicationRequirementId);

        if (checklistItem) {
            return this.updateRequirementStatus({
                ...checklistItem,
                ischecked: false,
                status: 'Pending',
                type:
                    data.jsondata.type === 'application' && targetedRequirement.jsondata.preapproval
                        ? 'preapproval'
                        : data.jsondata.type === 'application' && targetedRequirement.jsondata.postreservation
                        ? 'postreservation'
                        : data.jsondata.type,
                uploadedAt: moment(new Date()).utc().format(),
            });
        }
    }

    updateRequirementStatus(requirement: RequirementItems): void {
        if (requirement && requirement.status) {
            this.mutationService.updateRequirementStatus(this.status.application.id, requirement).subscribe((response) => {
                //console.log(response);
                if (response.data.updateRequirementChecklist) {
                    if (response.data.updateRequirementChecklist.checklist) {
                        this.checklistStatus = response.data.updateRequirementChecklist.checklist;
                    }
                }
            });
        }
    }

    async openTooltip(ev: any, type: string, icon: string) {
        const popover = await this.popoverCtrl.create({
            component: ApplicationInformationTooltipComponent,
            event: ev,
            mode: 'md',
            cssClass: 'info-tooltip-popover',
            showBackdrop: false,
            componentProps: {
                type: type,
                icon: icon,
                userEmail: this.status.user.email,
            },
        });
        return popover.present();
    }

    downloadSample() {
        const link = this.downloadZipLink.nativeElement;
        const hrefLink = this.textcontent.document.components.resources.unpaid.find((item) => item.name.includes("Sample Dean's Letter for a Rotation"));
        if (hrefLink) {
            link.href = hrefLink.url;
            link.target = '_blank';
            link.click();
        }
    }

    viewBasicDocument(doc: any) {
        this.angulartics2GoogleTagManager.eventTrack('Downloaded Personal Document', { category: 'Application Documents' });
        const request = {
            userid: this.status.application.userid,
            type: doc,
        };

        this.userService.getUploadedPersonalDocuments(request).subscribe((res) => {
            if (res.success && res.url) {
                window.open(res.url, '_blank');
            }
        });
    }

    viewMultipleDocs(documents, type) {
        //console.log(documents);
        let prefixRoute: string;

        if (type === 'immune') {
            prefixRoute = `userdocuments/${this.status.application.userid}/immunizations/`;
        } else if (type === 'healthinsurance') {
            prefixRoute = `userdocuments/${this.status.application.userid}/applications/${this.status.application.id}/healthinsurance/`;
        }

        const viewKeyDocs = documents.map((item) => ({ ...item, Key: prefixRoute + item.filename }));
        //console.log(viewKeyDocs);
        //console.log(this.status.application.userid);
        this.modalService.documentViewer(viewKeyDocs, this.status.application.userid).then(() => {
            /* empty */
        });
    }

    viewMalpracticeDocument = () => {
        window.open(this.userDocuments.malpracticeLink, '_blank');
    };

    viewAdditionalDocument(requirement, url?: string) {
        if (url && typeof url === 'string' && url.includes('https')) {
            window.open(url, '_blank');
            return;
        }

        let request = {
            userid: this.status.application.userid,
            applicationRequirementId: requirement.applicationRequirementId,
            type: requirement.jsondata.type,
            level: requirement.level,
            levelId: requirement.levelid,
            name: requirement.jsondata.name,
        };

        this.userService.getUploadedDocuments(request).subscribe((res: any) => {
            if (res.success && res.url) {
                window.open(res.url, '_blank');
            } else {
                this.warning.create('We were unable to process this request. Please contact support for assistance.');
            }
        });
    }

    downloadImmuneForm() {
        this.documentService.downloadImmunizationForm().subscribe((res: any) => {
            const base64str = res.Body.data;
            const binary = atob(base64str.replace(/\s/g, ''));
            const len = binary.length;
            const buffer = new ArrayBuffer(len);
            const view = new Uint8Array(buffer);
            for (let i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }
            const blob = new Blob([view], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            window.open(url);
            var a = document.createElement('a');
            a.href = url;
            a.target = '_blank';
            a.download = 'AMOpportunities_Certificate_of_Immunization.pdf';
            document.body.appendChild(a);
            a.click();

            // const link = this.downloadZipLink.nativeElement;
            // console.log(link);
            // link.href = url;
            // link.download =
            //     'AMOpportunities_Certificate_of_Immunization.pdf';
            // link.click();
            // window.URL.revokeObjectURL(url);
        });
    }
}
